import { Component, OnInit } from '@angular/core';
import { LocalizationService } from 'src/services/localization.service';

@Component({
  standalone: false,
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  constructor(public loc : LocalizationService) { }

  ngOnInit() {
  }

}
